import { IPopularItems } from "../../ISearch";

export const popularItemsSv: Array<IPopularItems> = [
  {
    label: "Kyckling",
    href: "/search?s=kyckling"
  },
  {
    label: "Pizza",
    href: "/search?s=pizza"
  },
  {
    label: "Keto",
    href: "/search?s=keto"
  },
  {
    label: "Bröd",
    href: "/search?s=bröd"
  },
  {
    label: "Lax",
    href: "/search?s=lax"
  },
  {
    label: "Fröknäcke",
    href: "/search?s=fröknäcke"
  },
  {
    label: "Köttfärs",
    href: "/search?s=köttfärs"
  },
  {
    label: "Frukost",
    href: "/search?s=frukost"
  },
  {
    label: "Guider",
    href: "/lchf/guider"
  },
  {
    label: "Videos",
    href: "/video"
  }
];
